import { BrowserDetectionService } from '../browser-detection';

export enum UnifiedSearchParams {
  QUERY = 'query',
  PAGE = 'page',
}

export const HistoryService = {
  searchParams: {
    cludoQuery: UnifiedSearchParams.QUERY,
    cludoPage: UnifiedSearchParams.PAGE,
  },
  historyTracker: [],

  getActiveUrl(): URL {
    const { href } = (window?.frameElement?.ownerDocument || window).location;
    return new URL(href);
  },
  isHistoryBackClick(newUrl: URL): boolean {
    return newUrl.toString() === this.historyTracker[this.historyTracker.length - 2];
  },
  isHistoryForwardClick(): boolean {
    return window.history.state > HistoryService.historyTracker.length;
  },

  removeLastHistoryEntry(): void {
    this.historyTracker = this.historyTracker.slice(0, -1);
  },
  getUrlWithoutHash(url: URL): string {
    return url.toString()?.split('#')[0];
  },
  getParsedHash(hash: string): string {
    return hash?.split('#')[1];
  },
  shouldParamsUpdateHistory(currentUrl: URL, nextUrl: URL): boolean {
    return HistoryService.getUrlWithoutHash(currentUrl)
      !== HistoryService.getUrlWithoutHash(nextUrl);
  },
  updateHash(newUrl: URL): void {
    const { pathname, search } = window.location;
    const urlWithoutHash = `${pathname}${search}`;
    const hasHash = Boolean(newUrl.hash);

    if (!hasHash && BrowserDetectionService.isSafari()) {
      window.history.pushState(this.historyTracker.length, '', urlWithoutHash);
      return;
    }

    if (!hasHash) {
      window.history.replaceState(this.historyTracker.length, '', urlWithoutHash);
      return;
    }

    this.historyTracker.push(newUrl.toString());
    window.history.pushState(this.historyTracker.length, '', newUrl.toString());
  },
  updateHistory(newUrl: URL): void {
    const url = newUrl.toString();

    if (this.isHistoryForwardClick()) {
      this.historyTracker.push(url);
      return;
    }
    if (this.isHistoryBackClick(newUrl)) {
      this.removeLastHistoryEntry();
      return;
    }

    this.historyTracker.push(url);
    window.history.pushState(this.historyTracker.length, '', url);
  },

  updateHistoryForSearch(newUrl: URL): void {
    const url = newUrl.toString();

    this.historyTracker.push(url);
    window.history.pushState(this.historyTracker.length, '', url);
  },

  replaceHistory(newUrl: URL): void {
    const url = newUrl.toString();

    if (this.isHistoryForwardClick()) {
      this.historyTracker[this.historyTracker.length - 1] = url;
      return;
    }

    if (this.isHistoryBackClick(newUrl)) {
      this.removeLastHistoryEntry();
      return;
    }

    this.historyTracker[this.historyTracker.length - 1] = url;
    window.history.replaceState(this.historyTracker.length, '', url);
  },
};
